<rask-page
    pageTitle="Produktinstruktioner"
    [actionShow]="canCreate()"
    [actionFn]="create"
    actionTitle="Skapa produktinstruktion"
    noPadding>
    <ng-container headerContent>
        <rask-produktinstruktioner-search></rask-produktinstruktioner-search>

    <rask-produktinstruktioner-search-result [events]="downloadPinEvent"
        [massEditEvent]="massEditEvent"></rask-produktinstruktioner-search-result> </ng-container>
    <ng-container footerContent>
        <rask-button color="secondary" popoverClass="pin-popover"
            placement="top-left"
            [autoClose]="'outside'"
            [ngbPopover]="downloadPinPopup"><span class="fas fa-download"></span> PIN</rask-button>
        <rask-button color="secondary" (click)="edit()" [disabled]="!canMassEdit()"><span class="fas fa-edit"></span>
            Massändra</rask-button>
        <rask-list-selected-items [data]="getSelectedListItems()" (removeFromSelection)="removeFromSelection($event)"></rask-list-selected-items>
    </ng-container>
</rask-page>


<ng-template #downloadPinPopup>
        <rask-produktinstruktioner-download [getSelectedPuids]="getSelectedPuids" [getFileName]="getFileName"></rask-produktinstruktioner-download>
</ng-template>
